module.exports = __webpack_public_path__ + "img/symbol_5.521a0480.png";